import { Injectable } from '@angular/core';
import { Pregunta } from 'src/app/model/pregunta';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from 'src/app/app-config.service';


@Injectable({
  providedIn: 'root'
})
export class ResultadoService {

  private url_obtenerEstadistica = '';
  private url_estadisticaPregunta = '';
  private url_iniciarVotacion = '';
  private url_finalizarVotacion = '';
  private url_actualizarTiempoAsignado = '';

  constructor(private _http: HttpClient, private appConfigService: AppConfigService) {
    this.loadConfig();
  }

  loadConfig() {
    const conf = this.appConfigService.getConfig();
    this.url_obtenerEstadistica = conf.apiEndpoint + '/pregunta/traerPreguntaAsamblea';
    this.url_estadisticaPregunta = conf.apiEndpoint + '/pregunta/estadisticasPregunta';
    this.url_iniciarVotacion = conf.apiEndpoint + '/pregunta/iniciarVotacionPregunta';
    this.url_finalizarVotacion = conf.apiEndpoint + '/pregunta/finalizarVotacionPregunta';
    this.url_actualizarTiempoAsignado = conf.apiEndpoint + '/pregunta/configurarTiempoPregunta';
  }

  obtenerEstadistica(_idAsamblea: number, _idPregunta: number) {
    return this._http.post(this.url_estadisticaPregunta, {
      valor: _idAsamblea,
      nombre: _idPregunta
    }).toPromise();
  }

  listarPreguntas(_idAsamblea: number) {
    return this._http.post(this.url_obtenerEstadistica, { valor: _idAsamblea, nombre: '' }).toPromise();
  }

  iniciarVotacion(_idAsamblea: number, _idPregunta: number) {
    return this._http.post(this.url_iniciarVotacion, { valor: _idAsamblea, nombre: _idPregunta }).toPromise();
  }

  finalizarVotacion(_idAsamblea: number, _idPregunta: number, _orden: number) {
    return this._http.post(this.url_finalizarVotacion, { idAsamblea: _idAsamblea, idPregunta: _idPregunta, orden: _orden }).toPromise();
  }

  aumentarTiempoAsignado(_pregunta: Pregunta) {
    let operador = 'A';
    if (_pregunta.tiempoAdicional < 0) {
      operador = 'R';
      _pregunta.tiempoAdicional = _pregunta.tiempoAdicional * -1;
    }
    return this._http.post(this.url_actualizarTiempoAsignado, {
      idAsamblea: _pregunta.idAsamblea,
      idPregunta: _pregunta.id,
      modo: operador,
      tiempoAdicional: _pregunta.tiempoAdicional
    }).toPromise();
  }
}
